@if (layout === 'empty') {
    <empty-layout></empty-layout>
}
@if (layout === 'classic') {
    <classic-layout></classic-layout>
}
